import { Message } from './Message.js';
import * as JSONLong from 'json-long';

var CommandType;
(function (CommandType) {
    CommandType[CommandType["MarkConversationRead"] = 1] = "MarkConversationRead";
    CommandType[CommandType["DeleteMessage"] = 2] = "DeleteMessage";
    CommandType[CommandType["DeleteConversation"] = 3] = "DeleteConversation";
    CommandType[CommandType["SettingInfoUpdate"] = 4] = "SettingInfoUpdate";
    CommandType[CommandType["CoreInfoUpdate"] = 6] = "CoreInfoUpdate";
    CommandType[CommandType["ParticipantUpdate"] = 7] = "ParticipantUpdate";
    CommandType[CommandType["FirstMessage"] = 8] = "FirstMessage"; // FIRST_MESSAGE
})(CommandType || (CommandType = {}));
class CommandMessage extends Message {
    static fromMessage(msg) {
        const cmdMessage = msg;
        cmdMessage.contentObj = JSONLong.parse(msg.content); // body里的字段是int64, 需要解成long
        cmdMessage.commandSubType = cmdMessage.contentObj.command_type;
        return cmdMessage;
    }
}

export { CommandMessage, CommandType };
//# sourceMappingURL=CommandMessage.js.map
